// Price helpers for the per-group price inputs (ParticipantGroupPriceMatrix, event/process forms).
// Prefills come from the template chain (GET /ProcessTemplate/{id}/PriceDefaults, entry price only); the former
// system price "Entry" moved into the participant groups, add-on prices live in the catalog / per process.

// Number -> value for <input type="number" step="0.01">: "20.00". null/invalid -> ''.
export function toPriceInput(value) {
  if (value == null || value === '') return '';
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : '';
}

// Input string -> number (rounded to cents), null when empty, NaN when invalid or negative.
export function parsePriceInput(value) {
  const raw = String(value ?? '').trim().replace(',', '.');
  if (raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return NaN;
  return Math.round(n * 100) / 100;
}

export const samePrice = (a, b) => Math.round(Number(a ?? 0) * 100) === Math.round(Number(b ?? 0) * 100);

// German currency display: 20 -> "20,00 €" (same format as the backend {Betrag} placeholder).
// Single definition lives in util/payment.js (dependency-free); re-exported for existing imports.
export { formatEuro } from './payment';
